import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { Checkbox } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import {
  SearchBar,
  StyledListContainer,
  RecipientRow,
  RecipientInfo,
  RecipientName,
  RecipientSubText,
  HelperText,
} from '../../styles';
import parentText from '../../text.json';
import texts from './texts.json';
import {
  ExcludeSection,
  ExcludeDrawerContainer,
  ExcludeDrawerToggle,
  ExcludeDrawerChevron,
  ExcludeDrawerContent,
  ExclusionSummary,
} from './styles';

const ExcludeTagsDrawer = ({
  excludedTags,
  onTagToggle,
  tagsList,
  searchQuery,
  onSearchQueryChange,
  isOpen,
  onToggleOpen,
  removedCount,
  includedCount,
}) => (
  <ExcludeSection>
    {excludedTags.size > 0 && removedCount > 0 && (
      <ExclusionSummary>
        {format(texts.exclusionSummary, { count: removedCount, included: includedCount })}
      </ExclusionSummary>
    )}

    <ExcludeDrawerContainer $isOpen={isOpen}>
      <ExcludeDrawerToggle type="button" onClick={onToggleOpen}>
        <span>
          {texts.excludeTagsLabel}
          {excludedTags.size > 0 && ` (${excludedTags.size})`}
        </span>
        <ExcludeDrawerChevron $isOpen={isOpen}><ExpandMoreIcon fontSize="small" /></ExcludeDrawerChevron>
      </ExcludeDrawerToggle>

      {isOpen && (
        <ExcludeDrawerContent>
          <HelperText>{texts.excludeTagsHelper}</HelperText>
          <SearchBar
            size="small"
            placeholder={texts.searchExcludeTags}
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
          />
          <StyledListContainer>
            {tagsList.length === 0 ? (
              <RecipientRow>
                <RecipientInfo>
                  <RecipientName>{parentText.noTagsFound}</RecipientName>
                </RecipientInfo>
              </RecipientRow>
            ) : (
              tagsList.map((tag) => (
                <RecipientRow key={tag.id} onClick={() => onTagToggle(tag.id)}>
                  <RecipientInfo>
                    <RecipientName>{tag.label}</RecipientName>
                    <RecipientSubText>{format(parentText.clients, { count: tag.count })}</RecipientSubText>
                  </RecipientInfo>
                  <Checkbox
                    checked={excludedTags.has(tag.id)}
                    onChange={() => onTagToggle(tag.id)}
                    onClick={(e) => e.stopPropagation()}
                    size="small"
                  />
                </RecipientRow>
              ))
            )}
          </StyledListContainer>
        </ExcludeDrawerContent>
      )}
    </ExcludeDrawerContainer>
  </ExcludeSection>
);

ExcludeTagsDrawer.propTypes = {
  excludedTags: PropTypes.instanceOf(Set).isRequired,
  onTagToggle: PropTypes.func.isRequired,
  tagsList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
  })).isRequired,
  searchQuery: PropTypes.string.isRequired,
  onSearchQueryChange: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggleOpen: PropTypes.func.isRequired,
  removedCount: PropTypes.number.isRequired,
  includedCount: PropTypes.number.isRequired,
};

export default ExcludeTagsDrawer;
